import { render, staticRenderFns } from "./SatIcon.vue?vue&type=template&id=22aaa15e&scoped=true"
import script from "./SatIcon.vue?vue&type=script&lang=js"
export * from "./SatIcon.vue?vue&type=script&lang=js"
import style0 from "./SatIcon.vue?vue&type=style&index=0&id=22aaa15e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aaa15e",
  null
  
)

export default component.exports